import { CatalogItemType } from '@pushly/models/lib/enums'
import { extractCampaignTrigger } from '../../../_utils/campaigns'

/**
 * Returns the default catalog item type for the domain.
 * Falls back to Product when domain.ecommConfig.itemType is undefined.
 */
export function getDefaultCatalogItemType(domain: any): CatalogItemType {
  return (domain?.ecommConfig?.itemType as CatalogItemType | undefined) ?? CatalogItemType.PRODUCT
}

/**
 * Safely extract item_type from a campaign's trigger configuration.
 * - Returns undefined if no trigger, no params.item_type, or if value cannot be normalized.
 * - Normalizes strings by lowercasing and attempts to match against CatalogItemType values.
 */
export function getItemTypeFromTrigger(campaign: any): CatalogItemType | undefined {
  try {
    const trigger = extractCampaignTrigger(campaign)
    const trigCfg = trigger?.getConfiguration?.()
    const raw = (trigCfg as any)?.params?.item_type
    if (!raw) return undefined

    const rawStr = String(raw).toLowerCase()

    // Attempt direct match against enum values (string enums)
    const enumValues = Object.values(CatalogItemType) as Array<string>
    const direct = enumValues.find(v => String(v).toLowerCase() === rawStr)
    if (direct) return direct as unknown as CatalogItemType

    // Fallback normalization map to handle minor variations
    const map: Record<string, CatalogItemType | undefined> = {
      product: (CatalogItemType as any).PRODUCT,
      products: (CatalogItemType as any).PRODUCT,
      item: (CatalogItemType as any).PRODUCT,
      event: (CatalogItemType as any).EVENT,
      recipe: (CatalogItemType as any).RECIPE,
      collection: (CatalogItemType as any).COLLECTION,
      category: (CatalogItemType as any).CATEGORY,
    }

    return map[rawStr]
  } catch {
    return undefined
  }
}

/**
 * Returns the default max abandoned item age (in days) for the domain.
 * Falls back to 30 when domain.ecommConfig.maxAbandonedItemAgeDays is undefined.
 */
export function getDefaultMaxAbandonedItemAgeDays(domain: any): number {
  return (domain?.ecommConfig?.maxAbandonedItemAgeDays as number | undefined) ?? 30
}
